const CLIENT_ID =
  "520461057957-7cvsvlgpl4opomblklrrhqbnr229fl5l.apps.googleusercontent.com";
// Gmail 送信に加え、トークンの実アカウント確認 (userinfo) に必要な openid/email を要求する。
const SCOPES = "https://www.googleapis.com/auth/gmail.send openid email";
// アカウント選択・同意画面を社内 Workspace ドメインのアカウントに限定するヒント。
const WORKSPACE_DOMAIN = "morimatsu.jp";

export { CLIENT_ID, SCOPES, WORKSPACE_DOMAIN };
